/**
 * Passaggio read-only fra un risultato strutturato di Martina e l'Esplora dati.
 * La query arriva da un tool gia' validato dal server, ma viene comunque
 * rivalidata da POST /api/crm-query/execute quando la vista e' aperta.
 */
export type MartinaCrmQueryView = {
  entityType: 'company' | 'contact' | 'branch' | 'lead' | 'deal' | 'synergy' | 'email' | 'task' | 'meeting' | 'brand' | 'file';
  match?: 'all' | 'any';
  filters?: Array<Record<string, unknown>>;
  filterGroup?: Record<string, unknown>;
  sorts?: Array<Record<string, unknown>>;
  columns?: string[];
  limit?: number;
  offset?: number;
};

const entityTypes = new Set<MartinaCrmQueryView['entityType']>([
  'company', 'contact', 'branch', 'lead', 'deal', 'synergy', 'email', 'task', 'meeting', 'brand', 'file',
]);
const parameter = 'martinaQuery';
const maxEncodedQueryLength = 6_000;

export function isMartinaCrmQueryView(value: unknown): value is MartinaCrmQueryView {
  return Boolean(value)
    && typeof value === 'object'
    && !Array.isArray(value)
    && entityTypes.has((value as { entityType?: MartinaCrmQueryView['entityType'] }).entityType!);
}

export function martinaCrmQueryViewPath(query: MartinaCrmQueryView): string | null {
  if (!isMartinaCrmQueryView(query)) return null;
  const encoded = encodeURIComponent(JSON.stringify(query));
  return encoded.length <= maxEncodedQueryLength ? `/data-explorer?${parameter}=${encoded}` : null;
}

export function parseMartinaCrmQueryView(pathnameWithSearch: string): MartinaCrmQueryView | null {
  try {
    const search = pathnameWithSearch.includes('?') ? pathnameWithSearch.slice(pathnameWithSearch.indexOf('?')) : '';
    const encoded = new URLSearchParams(search).get(parameter);
    if (!encoded || encoded.length > maxEncodedQueryLength) return null;
    const parsed = JSON.parse(encoded);
    return isMartinaCrmQueryView(parsed) ? parsed : null;
  } catch {
    return null;
  }
}
